export default {
    props: {
        valueAxisAxisCrossingValue: {
            type: [Object, Date, Array, String, Number],
            default: undefined,
            kComposite: 'valueAxis.axisCrossingValue'
        }, 
        valueAxisBackground: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.background'
        }, 
        valueAxisColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.color'
        }, 
        valueAxisCrosshairColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.crosshair.color'
        }, 
        valueAxisCrosshairOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.crosshair.opacity'
        }, 
        valueAxisCrosshairTooltipBackground: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.crosshair.tooltip.background'
        }, 
        valueAxisCrosshairTooltipBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.crosshair.tooltip.border.color'
        }, 
        valueAxisCrosshairTooltipBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.crosshair.tooltip.border.dashType'
        }, 
        valueAxisCrosshairTooltipBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.crosshair.tooltip.border.width'
        }, 
        valueAxisCrosshairTooltipColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.crosshair.tooltip.color'
        }, 
        valueAxisCrosshairTooltipFont: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.crosshair.tooltip.font'
        }, 
        valueAxisCrosshairTooltipFormat: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.crosshair.tooltip.format'
        }, 
        valueAxisCrosshairTooltipPadding: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.crosshair.tooltip.padding'
        }, 
        valueAxisCrosshairTooltipPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.crosshair.tooltip.padding.bottom'
        }, 
        valueAxisCrosshairTooltipPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.crosshair.tooltip.padding.left'
        }, 
        valueAxisCrosshairTooltipPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.crosshair.tooltip.padding.right'
        }, 
        valueAxisCrosshairTooltipPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.crosshair.tooltip.padding.top'
        }, 
        valueAxisCrosshairTooltipTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'valueAxis.crosshair.tooltip.template'
        }, 
        valueAxisCrosshairTooltipVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.crosshair.tooltip.visible'
        }, 
        valueAxisCrosshairVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.crosshair.visible'
        }, 
        valueAxisCrosshairWidth: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.crosshair.width'
        }, 
        valueAxisLabelsBackground: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.labels.background'
        }, 
        valueAxisLabelsBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.labels.border.color'
        }, 
        valueAxisLabelsBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.labels.border.dashType'
        }, 
        valueAxisLabelsBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.labels.border.width'
        }, 
        valueAxisLabelsColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.labels.color'
        }, 
        valueAxisLabelsFont: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.labels.font'
        }, 
        valueAxisLabelsFormat: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.labels.format'
        }, 
        valueAxisLabelsMargin: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.labels.margin'
        }, 
        valueAxisLabelsMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.labels.margin.bottom'
        }, 
        valueAxisLabelsMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.labels.margin.left'
        }, 
        valueAxisLabelsMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.labels.margin.right'
        }, 
        valueAxisLabelsMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.labels.margin.top'
        }, 
        valueAxisLabelsMirror: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.labels.mirror'
        }, 
        valueAxisLabelsPadding: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.labels.padding'
        }, 
        valueAxisLabelsPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.labels.padding.bottom'
        }, 
        valueAxisLabelsPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.labels.padding.left'
        }, 
        valueAxisLabelsPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.labels.padding.right'
        }, 
        valueAxisLabelsPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.labels.padding.top'
        }, 
        valueAxisLabelsRotation: {
            type: [Number, String],
            default: undefined,
            kComposite: 'valueAxis.labels.rotation'
        }, 
        valueAxisLabelsRotationAlign: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.labels.rotation.align'
        }, 
        valueAxisLabelsRotationAngle: {
            type: [Number, String],
            default: undefined,
            kComposite: 'valueAxis.labels.rotation.angle'
        }, 
        valueAxisLabelsSkip: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.labels.skip'
        }, 
        valueAxisLabelsStep: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.labels.step'
        }, 
        valueAxisLabelsTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'valueAxis.labels.template'
        }, 
        valueAxisLabelsVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.labels.visible'
        }, 
        valueAxisLabelsVisual: {
            type: Function,
            default: undefined,
            kComposite: 'valueAxis.labels.visual'
        }, 
        valueAxisLineColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.line.color'
        }, 
        valueAxisLineDashType: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.line.dashType'
        }, 
        valueAxisLineVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.line.visible'
        }, 
        valueAxisLineWidth: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.line.width'
        }, 
        valueAxisMajorGridLinesColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.majorGridLines.color'
        }, 
        valueAxisMajorGridLinesDashType: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.majorGridLines.dashType'
        }, 
        valueAxisMajorGridLinesType: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.majorGridLines.type'
        }, 
        valueAxisMajorGridLinesVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.majorGridLines.visible'
        }, 
        valueAxisMajorGridLinesWidth: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.majorGridLines.width'
        }, 
        valueAxisMajorGridLinesStep: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.majorGridLines.step'
        }, 
        valueAxisMajorGridLinesSkip: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.majorGridLines.skip'
        }, 
        valueAxisMajorUnit: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.majorUnit'
        }, 
        valueAxisMax: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.max'
        }, 
        valueAxisMin: {
            type: [Number, Object],
            default: undefined,
            kComposite: 'valueAxis.min'
        }, 
        valueAxisMinorGridLinesColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.minorGridLines.color'
        }, 
        valueAxisMinorGridLinesDashType: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.minorGridLines.dashType'
        }, 
        valueAxisMinorGridLinesType: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.minorGridLines.type'
        }, 
        valueAxisMinorGridLinesVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.minorGridLines.visible'
        }, 
        valueAxisMinorGridLinesWidth: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.minorGridLines.width'
        }, 
        valueAxisMinorGridLinesStep: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.minorGridLines.step'
        }, 
        valueAxisMinorGridLinesSkip: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.minorGridLines.skip'
        }, 
        valueAxisMajorTicksColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.majorTicks.color'
        }, 
        valueAxisMajorTicksSize: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.majorTicks.size'
        }, 
        valueAxisMajorTicksVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.majorTicks.visible'
        }, 
        valueAxisMajorTicksStep: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.majorTicks.step'
        }, 
        valueAxisMajorTicksSkip: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.majorTicks.skip'
        }, 
        valueAxisMinorTicksColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.minorTicks.color'
        }, 
        valueAxisMinorTicksSize: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.minorTicks.size'
        }, 
        valueAxisMinorTicksVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.minorTicks.visible'
        }, 
        valueAxisMinorTicksWidth: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.minorTicks.width'
        }, 
        valueAxisMinorTicksStep: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.minorTicks.step'
        }, 
        valueAxisMinorTicksSkip: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.minorTicks.skip'
        }, 
        valueAxisMinorUnit: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.minorUnit'
        }, 
        valueAxisName: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.name'
        }, 
        valueAxisNarrowRange: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.narrowRange'
        }, 
        valueAxisPane: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.pane'
        }, 
        valueAxisPlotBands: {
            type: Array,
            default: undefined,
            kComposite: 'valueAxis.plotBands'
        },         valueAxisReverse: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.reverse'
        }, 
        valueAxisTitleBackground: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.title.background'
        }, 
        valueAxisTitleBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.title.border.color'
        }, 
        valueAxisTitleBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.title.border.dashType'
        }, 
        valueAxisTitleBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.title.border.width'
        }, 
        valueAxisTitleColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.title.color'
        }, 
        valueAxisTitleFont: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.title.font'
        }, 
        valueAxisTitleMargin: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.title.margin'
        }, 
        valueAxisTitleMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.title.margin.bottom'
        }, 
        valueAxisTitleMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.title.margin.left'
        }, 
        valueAxisTitleMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.title.margin.right'
        }, 
        valueAxisTitleMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.title.margin.top'
        }, 
        valueAxisTitlePadding: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.title.padding'
        }, 
        valueAxisTitlePaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.title.padding.bottom'
        }, 
        valueAxisTitlePaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.title.padding.left'
        }, 
        valueAxisTitlePaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.title.padding.right'
        }, 
        valueAxisTitlePaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.title.padding.top'
        }, 
        valueAxisTitlePosition: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.title.position'
        }, 
        valueAxisTitleRotation: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.title.rotation'
        }, 
        valueAxisTitleText: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.title.text'
        }, 
        valueAxisTitleVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.title.visible'
        }, 
        valueAxisTitleVisual: {
            type: Function,
            default: undefined,
            kComposite: 'valueAxis.title.visual'
        }, 
        valueAxisType: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.type'
        }, 
        valueAxisVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.visible'
        }, 
        valueAxisNotesPosition: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.notes.position'
        }, 
        valueAxisNotesIconBackground: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.notes.icon.background'
        }, 
        valueAxisNotesIconBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.notes.icon.border.color'
        }, 
        valueAxisNotesIconBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.notes.icon.border.width'
        }, 
        valueAxisNotesIconSize: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.notes.icon.size'
        }, 
        valueAxisNotesIconType: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.notes.icon.type'
        }, 
        valueAxisNotesIconVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.notes.icon.visible'
        }, 
        valueAxisNotesLabelBackground: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.notes.label.background'
        }, 
        valueAxisNotesLabelBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.notes.label.border.color'
        }, 
        valueAxisNotesLabelBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.notes.label.border.dashType'
        }, 
        valueAxisNotesLabelBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.notes.label.border.width'
        }, 
        valueAxisNotesLabelColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.notes.label.color'
        }, 
        valueAxisNotesLabelFont: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.notes.label.font'
        }, 
        valueAxisNotesLabelTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'valueAxis.notes.label.template'
        }, 
        valueAxisNotesLabelVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'valueAxis.notes.label.visible'
        }, 
        valueAxisNotesLabelRotation: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.notes.label.rotation'
        }, 
        valueAxisNotesLabelFormat: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.notes.label.format'
        }, 
        valueAxisNotesLabelPosition: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.notes.label.position'
        }, 
        valueAxisNotesLineDashType: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.notes.line.dashType'
        }, 
        valueAxisNotesLineWidth: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.notes.line.width'
        }, 
        valueAxisNotesLineColor: {
            type: String,
            default: undefined,
            kComposite: 'valueAxis.notes.line.color'
        }, 
        valueAxisNotesLineLength: {
            type: Number,
            default: undefined,
            kComposite: 'valueAxis.notes.line.length'
        }, 
        valueAxisNotesData: {
            type: Array,
            default: undefined,
            kComposite: 'valueAxis.notes.data'
        },         valueAxisNotesVisual: {
            type: Function,
            default: undefined,
            kComposite: 'valueAxis.notes.visual'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoChartBase/ValueAxis.js